module.exports = __webpack_public_path__ + "img/userB09.6829d326.jpg";